/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Cancel_Addon_CopilotInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot" |
*
* @param {Sub_Cancel_Addon_CopilotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_cancel_addon_copilot = /** @type {((inputs?: Sub_Cancel_Addon_CopilotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Cancel_Addon_CopilotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot")
	return /** @type {LocalizedString} */ ("Compliance Copilot")
});